export default __webpack_public_path__ + "static/media/44.cd30d0d4.jpeg";